/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenericBenefit } from './GenericBenefit';
import {
    GenericBenefitFromJSON,
    GenericBenefitFromJSONTyped,
    GenericBenefitToJSON,
    GenericBenefitToJSONTyped,
} from './GenericBenefit';
import type { LTR } from './LTR';
import {
    LTRFromJSON,
    LTRFromJSONTyped,
    LTRToJSON,
    LTRToJSONTyped,
} from './LTR';

/**
 * 
 * @export
 * @interface InsuranceSection
 */
export interface InsuranceSection {
    /**
     * 
     */
    coverage_level?: string;
    /**
     * 
     */
    insurance_type?: string;
    /**
     * 
     */
    insurance_description?: string;
    /**
     * 
     */
    ltr?: LTR;
    /**
     * 
     */
    limitations?: Array<GenericBenefit>;
    /**
     * 
     */
    exclusions?: Array<GenericBenefit>;
    /**
     * 
     */
    deductibles?: Array<GenericBenefit>;
    /**
     * 
     */
    out_of_pocket?: Array<GenericBenefit>;
    /**
     * 
     */
    benefit_descriptions?: Array<GenericBenefit>;
    /**
     * 
     */
    coinsurances?: Array<GenericBenefit>;
    /**
     * 
     */
    copayments?: Array<GenericBenefit>;
    /**
     * 
     */
    reserves?: Array<GenericBenefit>;
    /**
     * 
     */
    active_coverages?: Array<GenericBenefit>;
    /**
     * 
     */
    inactive_coverages?: Array<GenericBenefit>;
    /**
     * 
     */
    non_covered_coverages?: Array<GenericBenefit>;
}

/**
 * Check if a given object implements the InsuranceSection interface.
 */
export function instanceOfInsuranceSection(value: object): value is InsuranceSection {
    return true;
}

export function InsuranceSectionFromJSON(json: any): InsuranceSection {
    return InsuranceSectionFromJSONTyped(json, false);
}

export function InsuranceSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceSection {
    if (json == null) {
        return json;
    }
    return {
        
        'coverage_level': json['coverage_level'] == null ? undefined : json['coverage_level'],
        'insurance_type': json['insurance_type'] == null ? undefined : json['insurance_type'],
        'insurance_description': json['insurance_description'] == null ? undefined : json['insurance_description'],
        'ltr': json['ltr'] == null ? undefined : LTRFromJSON(json['ltr']),
        'limitations': json['limitations'] == null ? undefined : ((json['limitations'] as Array<any>).map(GenericBenefitFromJSON)),
        'exclusions': json['exclusions'] == null ? undefined : ((json['exclusions'] as Array<any>).map(GenericBenefitFromJSON)),
        'deductibles': json['deductibles'] == null ? undefined : ((json['deductibles'] as Array<any>).map(GenericBenefitFromJSON)),
        'out_of_pocket': json['out_of_pocket'] == null ? undefined : ((json['out_of_pocket'] as Array<any>).map(GenericBenefitFromJSON)),
        'benefit_descriptions': json['benefit_descriptions'] == null ? undefined : ((json['benefit_descriptions'] as Array<any>).map(GenericBenefitFromJSON)),
        'coinsurances': json['coinsurances'] == null ? undefined : ((json['coinsurances'] as Array<any>).map(GenericBenefitFromJSON)),
        'copayments': json['copayments'] == null ? undefined : ((json['copayments'] as Array<any>).map(GenericBenefitFromJSON)),
        'reserves': json['reserves'] == null ? undefined : ((json['reserves'] as Array<any>).map(GenericBenefitFromJSON)),
        'active_coverages': json['active_coverages'] == null ? undefined : ((json['active_coverages'] as Array<any>).map(GenericBenefitFromJSON)),
        'inactive_coverages': json['inactive_coverages'] == null ? undefined : ((json['inactive_coverages'] as Array<any>).map(GenericBenefitFromJSON)),
        'non_covered_coverages': json['non_covered_coverages'] == null ? undefined : ((json['non_covered_coverages'] as Array<any>).map(GenericBenefitFromJSON)),
    };
}

export function InsuranceSectionToJSON(json: any): InsuranceSection {
    return InsuranceSectionToJSONTyped(json, false);
}

export function InsuranceSectionToJSONTyped(value?: InsuranceSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coverage_level': value['coverage_level'],
        'insurance_type': value['insurance_type'],
        'insurance_description': value['insurance_description'],
        'ltr': LTRToJSON(value['ltr']),
        'limitations': value['limitations'] == null ? undefined : ((value['limitations'] as Array<any>).map(GenericBenefitToJSON)),
        'exclusions': value['exclusions'] == null ? undefined : ((value['exclusions'] as Array<any>).map(GenericBenefitToJSON)),
        'deductibles': value['deductibles'] == null ? undefined : ((value['deductibles'] as Array<any>).map(GenericBenefitToJSON)),
        'out_of_pocket': value['out_of_pocket'] == null ? undefined : ((value['out_of_pocket'] as Array<any>).map(GenericBenefitToJSON)),
        'benefit_descriptions': value['benefit_descriptions'] == null ? undefined : ((value['benefit_descriptions'] as Array<any>).map(GenericBenefitToJSON)),
        'coinsurances': value['coinsurances'] == null ? undefined : ((value['coinsurances'] as Array<any>).map(GenericBenefitToJSON)),
        'copayments': value['copayments'] == null ? undefined : ((value['copayments'] as Array<any>).map(GenericBenefitToJSON)),
        'reserves': value['reserves'] == null ? undefined : ((value['reserves'] as Array<any>).map(GenericBenefitToJSON)),
        'active_coverages': value['active_coverages'] == null ? undefined : ((value['active_coverages'] as Array<any>).map(GenericBenefitToJSON)),
        'inactive_coverages': value['inactive_coverages'] == null ? undefined : ((value['inactive_coverages'] as Array<any>).map(GenericBenefitToJSON)),
        'non_covered_coverages': value['non_covered_coverages'] == null ? undefined : ((value['non_covered_coverages'] as Array<any>).map(GenericBenefitToJSON)),
    };
}

